<template>
  <label
    v-on:click.stop.prevent="toggleCheckbox"
    :class="`bg-big-checkbox ${value && 'bg-big-checkbox--checked'}`"
    :for="id"
  >
    <input
      type="checkbox"
      class="bg-big-checkbox__input"
      v-bind="{ disabled, value, name, required }"
    />
    <div
      :class="`bg-big-checkbox__container ${
        value ? 'bg-big-checkbox__container--active' : null
      }`"
    >
      <slot></slot>
      <div class="bg-big-checkbox__label">{{ label }}</div>
      <div class="bg-big-checkbox__description">{{ description }}</div>
    </div>
  </label>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import BgIcon from "@/components/bg-icon";
export default {
  name: "bg-big-checkbox",
  components: {
    BgIcon,
  },
  props: {
    required: {
      type: Boolean,
    },
    description: {
      type: String,
    },
    label: {
      type: String,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    value: [Boolean],
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    name: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Function,
    },
    image: {
      type: String,
      default: "mobile",
    },
  },
  methods: {
    toggleCheckbox() {
      if (this.link) {
        this.link();
      }
      if (!this.disabled) {
        this.$emit("change", !this.value);
      }
    },
  },
};
</script>
